import { ChatAnswerStreamWidgets } from "./ChatAnswerStreamWidget";
import { ChatPlanProposalCard } from "./ChatPlanProposalCard";
import type {
  ChatAnswerWidget,
  ChatUiPlanProposal,
} from "./hooks/useChatUiActions";

interface ChatInlineActionWidgetsProps {
  answerWidgets: ChatAnswerWidget[];
  planProposal?: ChatUiPlanProposal | null;
  onPlanDisplayComplete?: (actionId: string) => void;
}

export function ChatInlineActionWidgets({
  answerWidgets,
  planProposal,
  onPlanDisplayComplete,
}: ChatInlineActionWidgetsProps) {
  const shouldShowPlanProposal = !!planProposal;
  return (
    <>
      {shouldShowPlanProposal ? (
        <ChatPlanProposalCard
          proposal={planProposal}
          onDisplayComplete={onPlanDisplayComplete}
        />
      ) : null}
      <ChatAnswerStreamWidgets widgets={answerWidgets} />
    </>
  );
}
